export const LEASE_TERM_CHOICES = {
  fixed: 'fixed',
  monthly: 'month-to-month',
};
